import _regenerator from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { getChannel, getHomeByCategory, getHome, getChildPageList, getDecorationList, getBorderConfig,
// 获取边框配置
getBorderConfigCategory // 获取二级边框配置
} from './api';
import { isEmpty } from '@/utils';
export default {
  methods: {
    loadBorderData: function loadBorderData(style_id) {
      var _this = this;
      return new Promise(function (resolve) {
        var _this$info = _this.info,
          channel_id = _this$info.channel_id,
          customer_id = _this$info.customer_id,
          module = _this$info.module,
          category_id = _this$info.category_id;
        var params = _objectSpread(_objectSpread(_objectSpread({}, module === 'admin' ? {
          channel_id: channel_id
        } : {}), ['plat_custom', 'service_custom', 'custom', 'plat_service_custom'].includes(module) ? {
          customer_id: customer_id
        } : {}), {}, {
          style_id: style_id
        });
        var req = getBorderConfig;
        if (category_id && category_id != '0') {
          req = getBorderConfigCategory;
          params.category_id = category_id;
        }
        req(params, module).then(function (res) {
          resolve(res.data);
        }).catch(function (_) {
          return resolve({});
        });
      });
    },
    /**
     * 点击单组件保存后回调,用于处理特殊逻辑
     * @param {*} style_id 当前装修页style_id 必传
     * @param {*} data 保存成功后接口返回数据 必传
     * @param {*} configData 当前保存组件整体数据,可用于更改 必传
     */
    updateCB: function updateCB(style_id, data, configData) {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              return _context.a(2, new Promise(function (resolve) {
                var key = configData.key;
                var unique_id = data.unique_id;
                var module = _this2.info.module;
                if (isEmpty(unique_id) || isEmpty(style_id)) {
                  resolve();
                  return;
                }
                var _this2$$route$query$t = _this2.$route.query.temp_id,
                  temp_id = _this2$$route$query$t === void 0 ? '' : _this2$$route$query$t;
                switch (configData.key) {
                  case 'goods_drawer':
                  case 'goods_drawer_basic':
                  case 'saas_module_plate':
                  case 'saas_module_plate_nav':
                  case 'saas_long_image':
                  case 'saas_module_plate_swipe':
                  case 'yanchu_goods_nav':
                  case 'yanchu_goods_list':
                  case 'lvmama_goods_nav':
                  case 'lvmama_goods_list':
                  case 'vip_card_nav':
                  case 'vip_card_list':
                  case 'common_nav':
                  case 'super_nav':
                    getDecorationList({
                      key: key,
                      unique_id: unique_id,
                      style_id: style_id,
                      is_template: temp_id && !['cur', 'new'].includes(temp_id) ? 1 : 0 //模版数据的 1 装修数据的传 0
                    }, module).then(function (res) {
                      _this2.$set(configData, 'default_value', res.data);
                    }).finally(function () {
                      resolve();
                    });
                    break;
                  case 'movie_nav':
                    var promises = configData.config.value.map(function (item) {
                      return _this2.getMovieList(configData, {
                        key: key,
                        unique_id: unique_id,
                        style_id: style_id,
                        type: item.type,
                        is_template: temp_id && !['cur', 'new'].includes(temp_id) ? 1 : 0 //模版数据的 1 装修数据的传 0
                      });
                    });
                    Promise.all(promises).finally(function () {
                      resolve();
                    });
                    // configData.config.value.forEach(item => {
                    // 	this.getMovieList(configData, {
                    // 		key,
                    // 		unique_id,
                    // 		style_id,
                    // 		type: item.type,
                    // 		is_template:
                    // 			temp_id && !['cur', 'new'].includes(temp_id) ? 1 : 0 //模版数据的 1 装修数据的传 0
                    // 	})
                    // })
                    break;
                  default:
                    resolve();
                }
              }));
          }
        }, _callee);
      }))();
    },
    /**
     * 电影产品分类组件 获取对应类型数据
     * @returns
     */
    getMovieList: function getMovieList(configData, params) {
      var _this3 = this;
      return new Promise(function (resolve) {
        var module = _this3.info.module;
        getDecorationList(params, module).then(function (res) {
          _this3.$set(configData, params.type + 'List', res.data);
        }).finally(function () {
          resolve();
        });
      });
    },
    // 获取路由信息
    getQueryInfo: function getQueryInfo() {
      var _this4 = this;
      var _this$$route$query = this.$route.query,
        channel_id = _this$$route$query.channel_id,
        company_name = _this$$route$query.company_name,
        _this$$route$query$sh = _this$$route$query.short_name,
        short_name = _this$$route$query$sh === void 0 ? '' : _this$$route$query$sh,
        _this$$route$query$co = _this$$route$query.contracted_company,
        contracted_company = _this$$route$query$co === void 0 ? '' : _this$$route$query$co,
        _this$$route$query$cu = _this$$route$query.customer_id,
        customer_id = _this$$route$query$cu === void 0 ? '' : _this$$route$query$cu,
        _this$$route$query$cu2 = _this$$route$query.customer_name,
        customer_name = _this$$route$query$cu2 === void 0 ? '' : _this$$route$query$cu2,
        _this$$route$query$ca = _this$$route$query.category_id,
        category_id = _this$$route$query$ca === void 0 ? '' : _this$$route$query$ca,
        _this$$route$query$me = _this$$route$query.menu,
        menu = _this$$route$query$me === void 0 ? '' : _this$$route$query$me,
        _this$$route$query$te = _this$$route$query.temp_id,
        temp_id = _this$$route$query$te === void 0 ? '' : _this$$route$query$te,
        _this$$route$query$te2 = _this$$route$query.temp_name,
        temp_name = _this$$route$query$te2 === void 0 ? '' : _this$$route$query$te2,
        _this$$route$query$st = _this$$route$query.style_id,
        style_id = _this$$route$query$st === void 0 ? '' : _this$$route$query$st,
        _this$$route$query$gr = _this$$route$query.group_type,
        group_type = _this$$route$query$gr === void 0 ? '' : _this$$route$query$gr,
        _this$$route$query$mo = _this$$route$query.mode,
        mode = _this$$route$query$mo === void 0 ? '' : _this$$route$query$mo,
        _this$$route$query$te3 = _this$$route$query.temp_type,
        temp_type = _this$$route$query$te3 === void 0 ? '' : _this$$route$query$te3,
        _this$$route$query$pa = _this$$route$query.page_source,
        page_source = _this$$route$query$pa === void 0 ? '' : _this$$route$query$pa;
      var common = {
        customer_id: customer_id,
        customer_name: customer_name,
        category_id: category_id,
        menu: menu,
        temp_id: temp_id,
        temp_name: temp_name,
        temp_type: temp_type,
        page_source: page_source,
        style_id: style_id,
        group_type: group_type
      };
      var module = mode; // 路由传入手动指定进入类型
      if (module === '') {
        // 如果没有手动指定类型 根据渠道ID或客户ID判断来源
        if (channel_id) {
          module = 'admin'; // 进入源为渠道列表 平台管理员为渠道装修
        } else if (customer_id) {
          module = 'custom'; // 进入源为客户列表 给客户装修
        } else {
          module = 'channel'; // 进入源为一级路由 渠道给自己装修
        }
      }
      return new Promise(/*#__PURE__*/function () {
        var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(resolve) {
          var res;
          return _regenerator().w(function (_context2) {
            while (1) switch (_context2.n) {
              case 0:
                if (!(channel_id || customer_id)) {
                  _context2.n = 1;
                  break;
                }
                resolve(_objectSpread(_objectSpread({
                  channel_id: channel_id,
                  company_name: company_name,
                  short_name: short_name,
                  contracted_company: contracted_company
                }, common), {}, {
                  module: module
                }));
                _context2.n = 3;
                break;
              case 1:
                _context2.n = 2;
                return _this4.loadChannel();
              case 2:
                res = _context2.v;
                resolve(_objectSpread(_objectSpread(_objectSpread({}, res.data), common), {}, {
                  module: module
                }));
              case 3:
                return _context2.a(2);
            }
          }, _callee2);
        }));
        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    },
    // 获取渠道
    loadChannel: function loadChannel() {
      return new Promise(function (resolve) {
        getChannel().then(function (res) {
          resolve(res);
        });
      });
    },
    // 获取主数据
    getHomeData: function getHomeData() {
      var _this5 = this;
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var template_config_id = props.template_config_id;
      return new Promise(function (resolve) {
        var _this5$info = _this5.info,
          channel_id = _this5$info.channel_id,
          customer_id = _this5$info.customer_id,
          category_id = _this5$info.category_id,
          temp_id = _this5$info.temp_id,
          module = _this5$info.module,
          style_id = _this5$info.style_id;
        var req = null;
        var params = _objectSpread(_objectSpread({}, module === 'admin' ? {
          channel_id: channel_id
        } : {}), ['plat_custom', 'service_custom', 'custom', 'plat_service_custom'].includes(module) ? {
          customer_id: customer_id
        } : {});

        // 判定是装修二级页面 还是 首页
        if (category_id) {
          // 二级
          req = getHomeByCategory;
          params.category_id = category_id;
        } else {
          // 一级
          req = getHome;
          if (['admin', 'channel'].includes(module)) {
            // 新扩展需求 装修首页增加主页面 & 被选页面概念
            params = _objectSpread(_objectSpread({}, params), {}, {
              new: Number(temp_id === 'new'),
              style_id: style_id
            });
          }
        }
        // 模板ID 如选择当前 或 新建时 不传递参数
        if (temp_id && !['cur', 'new'].includes(temp_id)) {
          params.template_id = temp_id;
          // 初次调用时 在home中传递template_config_id模板ID 背景设置配置项 后端取该模板的背景设置,不传则取该客户|渠道的背景设置
          params.template_config_id = template_config_id;
        }
        req(module, params).then(function (res) {
          resolve(res.data);
        });
      });
    },
    /**
     * 获取右侧配置项所需子页面菜单列表 三个页面公用
     * src/views/custom-layout/index.vue
     * src/views/custom-layout/indexChildren.vue
     * src/views/platformConfig/templateLibrary/customLayout.vue
     * @returns
     */
    getChildrenMenu: function getChildrenMenu() {
      var _this6 = this;
      var _this$info2 = this.info,
        module = _this$info2.module,
        channel_id = _this$info2.channel_id,
        customer_id = _this$info2.customer_id;
      var authPath = {
        admin: '/decoration/decoration/child-page-list',
        custom: '/decoration/decoration/child-page-list-customer',
        plat_custom: '/plat/decoration/child-page-list-customer',
        service_custom: '/kefu/decoration/child-page-list-customer',
        // 客服中心 - 客服工作台获取子页面数据 不校验权限
        plat_service_custom: '/plat-service/decoration/child-page-list-customer',
        // 平台客服 - 客服工作台获取子页面数据 不校验权限
        channel: '/decoration/decoration/child-page-list-shop'
      }[module];
      if (!['service_custom', 'plat_service_custom'].includes(module) && !this.$hasBtnRoles(authPath)) {
        return;
      }
      getChildPageList({
        channel_id: channel_id,
        customer_id: customer_id,
        sort_type: '1' // 用户专用子页面排在渠道通用之前
      }, module).then(function (res) {
        var data = res.data;
        _this6.childrenMenuList = data.list;
      });
    },
    getMagicTitle: function getMagicTitle(magic_type, index, type) {
      return {
        1: {
          0: ['竖图', '250*420'],
          1: ['方图（左）', '200*200'],
          2: ['方图（右）', '200*200'],
          3: ['横图', '420*200']
        },
        2: {
          0: ['方图（左）', '335*204'],
          1: ['方图（右）', '335*204'],
          2: ['横图', '690*153']
        },
        3: {
          0: ['横图', '690*153'],
          1: ['方图（左）', '335*204'],
          2: ['方图（右）', '335*204']
        },
        4: {
          0: ['方图（上）', '335*216'],
          1: ['方图（下）', '335*216'],
          2: ['竖图', '335*452']
        },
        5: {
          0: ['竖图', '335*452'],
          1: ['方图（上）', '335*216'],
          2: ['方图（下）', '335*216']
        },
        6: {
          0: ['方图（左）', '216*216'],
          1: ['方图（中）', '216*216'],
          2: ['方图（右）', '216*216']
        },
        7: {
          0: ['方图（左上）', '335*216'],
          1: ['方图（右上）', '335*216'],
          2: ['方图（左下）', '335*216'],
          3: ['方图（右下）', '335*216']
        },
        8: {
          0: ['图片1', '159*216'],
          1: ['图片2', '159*216'],
          2: ['图片3', '159*216'],
          3: ['图片4', '159*216']
        }
      }[magic_type][index][type];
    }
  }
};